import { defineAsyncComponent } from 'vue';
const VGrid = defineAsyncComponent(() => import('@revolist/vue3-datagrid'));
const IMDI = defineAsyncComponent(() => import('@/Components/Common/IMDI.vue'));
const IBreadcrumbs = defineAsyncComponent(() => import('@/Components/Common/IBreadcrumbs.vue'));
const IBox = defineAsyncComponent(() => import('@/Components/Common/IBox.vue'));
const IButton = defineAsyncComponent(() => import('@/Components/Common/IButton.vue'));
const IInputField = defineAsyncComponent(() => import('@/Components/Common/IInputField.vue'));
const IInputPeriod = defineAsyncComponent(() => import('@/Components/Common/IInputPeriod.vue'));
const IModal = defineAsyncComponent(() => import('@/Components/Common/IModal.vue'));
const ISectionHeader = defineAsyncComponent(() => import('@/Components/Common/ISectionHeader.vue'));
const IDirtyFormModal = defineAsyncComponent(() => import('@/Components/Common/IDirtyFormModal.vue'));
const IMultiselect = defineAsyncComponent(() => import('@/Components/Common/IMultiselect.vue'));
const IAlertConfirmModal = defineAsyncComponent(() => import('@/Components/Common/IAlertConfirmModal.vue'));
const CriticalMessage = defineAsyncComponent(() => import('@/Components/Authenticated/CriticalMessage.vue'));
const IFileUploadModal = defineAsyncComponent(() => import('@/Components/Common/IFileUploadModal.vue'));
const TranslationVideoDialog = defineAsyncComponent(() => import('@/Components/Authenticated/TranslationVideoDialog.vue'));

export default {
    install: (app) => {
        app.component('VGrid', VGrid);
        app.component('IMDI', IMDI);
        app.component('IBreadcrumbs', IBreadcrumbs);
        app.component('IBox', IBox);
        app.component('IButton', IButton);
        app.component('IInputField', IInputField);
        app.component('IInputPeriod', IInputPeriod);
        app.component('IModal', IModal);
        app.component('ISectionHeader', ISectionHeader);
        app.component('IDirtyFormModal', IDirtyFormModal);
        app.component('IMultiselect', IMultiselect);
        app.component('IAlertConfirmModal', IAlertConfirmModal);
        app.component('CriticalMessage', CriticalMessage);
        app.component('IFileUploadModal', IFileUploadModal);
        app.component('TranslationVideoDialog', TranslationVideoDialog);
    },
};
